import { theme } from '../../../ThemeContext/ThemeObject';
import {
  actionsMenuPaperCommonStyles,
  actionsMenuSpanCommonStyles,
  leftArrowStyles,
  rightArrowStyles
} from '../../shared/commonStyles';
import {
  notesEditSaveButton,
  notesCancelButton,
  fileName,
  editNotePopover,
  rowSelect,
  pagination,
  actionButton,
  paginationContainer,
  selectedTooltip,
  rowSelectContainer
} from '../../shared/styleClasses';

export const classes = {
  tableAndArrowsContainer: {
    position: 'relative'
  },
  tableWrapper: {
    tableLayout: 'auto !important',
    border: 'none',
    'td, th, tr, thead': {
      fontFamily: 'Source Sans Pro, sans-serif',
      border: 'none',
      backgroundColor: '#FFFFFF',
      textTransform: 'none'
    },
    th: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      paddingBottom: '16px',
      '& .Mui-active': {
        color: theme.palette.primary.main
      }
    },
    tr: {
      fontSize: '16px',
      borderBottom: '1px solid #DDDDDD'
    }
  },
  checkbox: {
    color: '#aaa !important',
    '& .MuiSvgIcon-root': {
      fontSize: '20px'
    },
    '&.Mui-checked': {
      color: '#15C7C0 !important'
    }
  },
  sortable: {
    '&:hover': {
      color: '#0C74A4'
    },
    '& .MuiTableSortLabel-icon': {
      color: 'darkgrey !important'
    },
    '& svg': {
      fontSize: '1.1rem'
    }
  },
  notSortable: {
    '& .MuiTableSortLabel-icon': {
      display: 'none'
    }
  },
  sticky: {
    position: 'sticky',
    left: '0px',
    background: 'white',
    zIndex: 2
  },
  stickyRight: {
    position: 'sticky',
    right: '0px',
    background: 'white'
  },
  paginationParent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '20px',
    width: '100%'
  },
  rowSelectContainer,
  paginationContainer,
  pagination,
  rowSelect,
  paginationMenuItems: {
    '& li': {
      fontFamily: 'Source Sans Pro'
    }
  },
  actionsColumnHeader: {
    zIndex: 4,
    minWidth: '86px',
    position: 'sticky',
    right: '0px',
    background: 'white',
    '&::after': {
      content: '""',
      background: '#aaaaaa',
      width: '2px',
      height: '100%',
      filter: 'blur(2px)',
      position: 'absolute',
      top: '0',
      left: '-2px',
      opacity: '0%',
      transition: 'opacity 0.17s linear'
    },
    '&::before': {
      content: '""',
      top: '0',
      left: '0',
      width: '6px',
      height: '100%',
      position: 'absolute',
      background: '#ffffff',
      zIndex: '2'
    }
  },
  scrollShadowVisible: {
    '&&::after': {
      opacity: '20%'
    }
  },
  actionsCell: {
    minWidth: '86px',
    width: '50px',
    '& svg': {
      color: '#666666',
      fontSize: '18px',
      cursor: 'pointer'
    }
  },
  idTableCell: {
    '& a': {
      color: 'rgba(0, 0, 0, 0.87)',
      '&:hover': {
        textDecoration: 'none',
        color: 'rgba(0, 0, 0, 0.87)'
      }
    },
    minWidth: '80px',
    left: '58px'
  },
  itemTitleTableCell: {
    minWidth: '200px',
    left: '138px',
    '& a': {
      color: '#666666',
      fontWeight: 'bold',
      '&:hover': {
        textDecoration: 'none'
      }
    },
    '&::after': {
      content: '""',
      background: '#aaaaaa',
      width: '2px',
      height: '100%',
      filter: 'blur(2px)',
      position: 'absolute',
      top: '0',
      right: '-2px',
      opacity: '0%',
      transition: 'opacity 0.17s linear'
    },
    '&::before': {
      content: '""',
      top: '0',
      right: '0',
      width: '6px',
      height: '100%',
      position: 'absolute',
      background: '#ffffff',
      zIndex: '2'
    }
  },
  actionsTableCell: {
    minWidth: '86px',
    width: '50px',
    '& svg': {
      color: '#666666',
      fontSize: '18px',
      cursor: 'pointer'
    },
    '&::after': {
      content: '""',
      background: '#aaaaaa',
      width: '2px',
      height: '100%',
      filter: 'blur(2px)',
      position: 'absolute',
      top: '0',
      left: '-2px',
      opacity: '0%',
      transition: 'opacity 0.17s linear'
    },
    '&::before': {
      content: '""',
      top: '0',
      left: '0',
      width: '6px',
      height: '100%',
      position: 'absolute',
      background: '#ffffff',
      zIndex: '2'
    }
  },
  actionItems: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  arrowsContainer: {
    height: 0,
    overflow: 'visible',
    position: 'sticky',
    top: '200px',
    zIndex: '10',
    transform: 'translateY(100px)'
  },
  leftArrow: {
    ...leftArrowStyles,
    position: 'absolute',
    zIndex: '11',
    bottom: 'auto'
  },
  rightArrow: {
    ...rightArrowStyles,
    position: 'absolute',
    zIndex: '11',
    bottom: 'auto'
  },
  showArrows: {
    display: 'flex',
    animation: '$fadeIn linear 0.17s'
  },
  '@keyframes fadeIn': {
    '0%': { opacity: 0 },
    '100%': { opacity: 0.9 }
  },
  noResultsContainer: {
    width: '100%',
    height: '400px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    rowGap: '42px',
    fontFamily: 'Source Sans Pro, sans-serif',
    color: '#DDDDDD',
    fontSize: '20px',
    fontWeight: 'bold',
    padding: '32px 0px'
  },
  noteContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '4px',
    overflow: 'hidden',
    maxHeight: '86px',
    textOverflow: 'ellipsis'
  },
  noteSubject: {
    fontWeight: 'bold'
  },
  noteUser: {
    padding: '4px 0px 10px 0px'
  },
  notesExpanded: {
    maxHeight: 'unset'
  },
  notesExpandContract: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },
  attachmentItem: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '10px',
    padding: '14px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F5F5F5'
    }
  },
  fileIcon: {
    color: theme.palette.primary.main
  },
  fileName,
  notesTitle: {
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    marginBottom: '12px',
    width: '100%'
  },
  editNotePopover,
  noteBox: {
    padding: '10px 12px',
    width: '100%',
    overflowWrap: 'break-word'
  },
  noteInput: {
    marginBottom: '4px',
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
    '& input': {
      padding: '9.5px 14px'
    }
  },
  notesButtonContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: '10px'
  },
  notesEditSaveButton,
  notesCancelButton,
  actionsContianer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '22px',
    paddingBottom: '16px'
  },
  actionButton,
  fadeIn: {
    visibility: 'visible',
    opacity: '1',
    transform: 'translateX(0px)',
    transition: 'visibility 0s linear 0s, opacity 300ms, transform 300ms'
  },
  fadeOut: {
    visibility: 'hidden',
    opacity: '0',
    transform: 'translateX(20px)',
    transition: 'visibility 0s linear 300ms, opacity 300ms, transform 300ms'
  },
  selectedTooltip,
  selectedTooltipText: {
    fontFamily: 'Source Sans Pro',
    fontSize: '20px',
    fontWeight: '600',
    color: '#084D6D'
  },
  selectedAllTooltipText: {
    color: '#084D6D',
    fontWeight: '700',
    textDecoration: 'underline',
    borderRadius: '10px',
    padding: '4px 12px',
    '&:hover': {
      background: 'rgba(171, 205, 239, 0.3)'
    }
  },
  selectAllWithActionsTooltip: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '700px',
    maxWidth: '100%',
    paddingInline: '20px',
    fontFamily: 'Source Sans Pro',
    fontSize: '24px',
    fontWeight: '600',
    color: '#084D6D'
  },
  selectAllWithActionsTooltipButton: {
    fontFamily: 'Source Sans Pro',
    fontSize: '15px',
    fontWeight: '600',
    color: '#666666',
    backgroundColor: '#9393931F',
    padding: '10px 24px',
    borderRadius: '6px',
    border: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#93939335',
      border: 'none'
    }
  },
  actionsMenu: {
    '& .MuiPaper-root': {
      ...actionsMenuPaperCommonStyles,
      width: '170px',
      marginTop: '6px'
    },
    '& span': actionsMenuSpanCommonStyles
  },
  centerCellContent: {
    display: 'flex',
    justifyContent: 'center'
  }
};
